// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74b70468","702":"f6705079"}[chunkId] + ".chunk.js";
};